import { render, staticRenderFns } from "./tabISF05.vue?vue&type=template&id=58c51832&scoped=true&"
import script from "./tabISF05.vue?vue&type=script&lang=js&"
export * from "./tabISF05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c51832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c51832')) {
      api.createRecord('58c51832', component.options)
    } else {
      api.reload('58c51832', component.options)
    }
    module.hot.accept("./tabISF05.vue?vue&type=template&id=58c51832&scoped=true&", function () {
      api.rerender('58c51832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabISF05.vue"
export default component.exports